import { extractRtkErrorMessage, formatApiMessage } from '@/services/apiErrors'

/**
 * Normalized application error for domain/presentation layers.
 */
export class AppError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'AppError'
  }
}

export function toAppError(error: unknown, fallback = 'Request failed. Please try again.'): AppError {
  if (error instanceof AppError) return error

  const axiosErr = error as {
    response?: { data?: { message?: unknown }; status?: number }
    message?: string
  }

  const message = extractRtkErrorMessage({
    data: axiosErr.response?.data,
    status: axiosErr.response?.status,
    error: axiosErr.message,
  })

  if (message && message !== 'Request failed. Please try again.') {
    return new AppError(message)
  }

  const direct = formatApiMessage(
    (error as { message?: unknown })?.message ?? axiosErr.response?.data?.message
  )
  if (direct) return new AppError(direct)

  return new AppError(fallback)
}
